import { motion } from "framer-motion";
import { Music2, Sparkles } from "lucide-react";
import React from "react";

interface ConnectSpotifyProps {
  onConnect: () => void;
}

export const ConnectSpotify: React.FC<ConnectSpotifyProps> = ({ onConnect }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gradient-to-br from-[#1DB954] to-[#1ed760] rounded-lg p-8 text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1614149162883-504ce4d13909?w=1200&auto=format&fit=crop&q=60')] opacity-10 bg-cover bg-center" />

      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-4">
          <Music2 className="w-8 h-8" />
          <h2 className="text-2xl font-bold">Connect with Spotify</h2>
        </div>

        <p className="text-white/80 mb-6 max-w-md">
          Link your Spotify account to unlock more features and see combined statistics across all your music.
        </p>

        <div className="space-y-4 mb-8">
          <div className="flex items-center gap-3">
            <Sparkles className="w-5 h-5 text-white/90" />
            <span>Access your Spotify playlists and liked songs</span>
          </div>
          <div className="flex items-center gap-3">
            <Sparkles className="w-5 h-5 text-white/90" />
            <span>Get personalized recommendations</span>
          </div>
          <div className="flex items-center gap-3">
            <Sparkles className="w-5 h-5 text-white/90" />
            <span>See combined listening statistics</span>
          </div>
        </div>

        <button
          onClick={onConnect}
          className="px-8 py-3 bg-white text-green-600 rounded-full font-semibold hover:bg-white/90 transition"
        >
          Connect Spotify
        </button>
      </div>
    </motion.div>
  );
};
